<template>
    <div>

        <config-main-title>
            Regra de Urgência Automática
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhuma Regra de Urgência Automática identificada.'" 
                icon="fa-solid fa-bell-exclamation"
                :action="'Incluir Regra'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>

                        <span class="badge badge-secondary ml-2">#{{  dado.id_auto_urg }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <span v-else>
                            <span class="badge badge-secondary" v-if="dado.st_record_id">
                                {{ dado.st_record_id }}
                            </span>
                        </span>
                    </span>
                </li>
            </div>
        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ ( item && item.id_auto_urg ) ? '' : 'Nova' }}
                            Regra
                            <span v-if="item && item.id_auto_urg">
                                #{{ item.id_auto_urg }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    label="Título"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Idade Mínima"
                                    type="number"
                                    placeholder="Idade Mínima..."
                                    :validate="validate"
                                    v-model="item.in_idade_minima" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input  
                                    label="Idade Máxima"
                                    type="number"
                                    placeholder="Idade Máxima..."
                                    required
                                    :validate="validate"
                                    v-model="item.in_idade_maxima" />
                            </div>
                        </div>

                        <!-- Lista de CIDS -->
                        <az-sub-title class="mt-3" title="Lista de CIDs">
                            <a class="card-link" href="#" @click.prevent="incluir_cid()">
                                <i class="fas fa-plus mr-2"></i>
                                Incluir Filtro
                            </a>
                        </az-sub-title>
                        <div class="form-row" v-if="item.js_lista_cids">
                            <div class="col col-12 col-md-3" v-for="(item_cid, icx) in item.js_lista_cids" :key="icx">
                                <az-input  
                                    sizing="sm"
                                    placeholder="CID (sem ponto e traço)..."
                                    required
                                    :validate="validate"
                                    v-model="item.js_lista_cids[icx]">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button type="button" class="btn btn-outline-danger" @click="item.js_lista_cids.splice(icx, 1)">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>

                        <div v-if="!item.js_lista_cids || !item.js_lista_cids.length" class="my-2 text-muted">
                            Nenhum CID Informado.
                        </div>

                        <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_cid()">
                            <i class="fas fa-plus"></i>
                        </button>

                        <!-- Outros Filtros -->
                        <filtro-model title="Filtros" class="my-3" v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="autoUrg" :id="item.id_auto_urg" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_auto_urg ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import FiltroModel from '../shared/FiltroModel.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
            is_reembolso: false, 
            is_infusao: false, 
        }
    },

    props: ['teste'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzSubTitle,
        AzAuditLogButton,
        FiltroModel, 
    },

    computed: { 
        lista_opcoes_filtro: function () { 
            let opcoes = [                        
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\amostraMaterial', search:'Material da Amostra', service: 'amostra_materiais.index'}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'}, 
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'},
                {id:'App\\azure\\apoiado', search:'Apoiado', service:'apoiados.index'},
                {id:'App\\azure\\apoiadoOrigem', search:'Apoiado - Origem', service:'apoiado_origens.index', parms: { lista_filtro: true }},
            ];

            opcoes = _.orderBy(opcoes, ['search'], ['asc']);
            
            return opcoes; 
        },

        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        },

    },

    methods: { 
        incluir_cid () { 
            if ( !this.item.js_lista_cids ) 
                this.item.js_lista_cids = [];

            this.item.js_lista_cids.push("");
        },

        serviceFiltro(model) { 
            let opcao = this.infoFiltroModel(model);
            return opcao ? opcao.service : null;
        },

        infoFiltroModel(model) { 
            if ( !this.lista_modelos || !model ) 
                return null;

            let opcao = this.lista_modelos.find(item => item.id == model);

            return opcao;
        },

        incluir () { 
            this.validate = false;

            let item = {
                id_auto_urg: null, 
                st_titulo: "", 
                fl_ativo: true, 
                js_lista_cids: [], 
                in_idade_minima: 0, 
                in_idade_maxima: 999, 
                filtros: [], 
            };

            this.editar (item);
        },
        load () { 
            this.$util.load(this, { 
                service:'auto_urgs',
                func: 'index',
                parms: { 
                    cadastro: true, 
                }
            });
        },
        editar (item) { 
            this.validate = false;

            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'auto_urgs',
                dados: this.item,
                reload: true, 
                modal: 'edicaoModal',
            });
        },

        toggle (item) { 

            this.$util.toggle(this, { 
                service: 'auto_urgs',
                dados: item,
            });

        },
    },

    mounted () { 
        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros"},
            { name: "Regra de Urgência Automática" },
        ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.load();

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>